import { Spinner, Flex } from '@grupoboticario/flora-react'

import { FadeIn } from '@/utils/useFadeIn/useFadeIn'

import * as S from './Loader.styles'

const Loader = ({ size = 'lg', speed = '800ms', thickness = '2px', height = 200 }) => {
  return (
    <FadeIn>
      <Flex align="center" css={S.loaderContainerCss(height)} justify="center">
        <Spinner data-testid="loader-spinner" size={size} speed={speed} thickness={thickness} />
      </Flex>
    </FadeIn>
  )
}

export default Loader
